// src/components/layout/ProtectedLayout.tsx

import React from 'react';
import { ProtectedRoute } from '@/components/auth/ProtectedRoute';
import { MainLayout } from './MainLayout';
import type { UserRole } from '@/config/routes.config';

interface ProtectedLayoutProps {
  children: React.ReactNode;
  requiredRole?: UserRole | UserRole[];
}

export const ProtectedLayout: React.FC<ProtectedLayoutProps> = ({
  children,
  requiredRole,
}) => {
  return (
    <ProtectedRoute requiredRole={requiredRole}>
      <MainLayout>{children}</MainLayout>
    </ProtectedRoute>
  );
};
